var React = require('react');

function SelfHost (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18 0V28H10V20H8V28H0V0H18ZM16 2H2V26H6V18H12V26H16V2ZM6 8H4V4H6V8ZM10 8H8V4H10V8ZM6 14H4V10H6V14ZM10 14H8V10H10V14ZM14 8H12V4H14V8ZM14 14H12V10H14V14Z","fill":"black","fillOpacity":"0.54"}));
}

SelfHost.defaultProps = {"width":"18","height":"28","viewBox":"0 0 18 28","fill":"none"};

module.exports = SelfHost;

SelfHost.default = SelfHost;
